module.exports = __webpack_public_path__ + "static/media/13.58d5ebc6.jpg";